<template>

	<div class="list-content">
		<ul class="type-webzine">

			<li v-for="(item, index) in noticeList" :id="'item-' + item.idx">
				<a href="javascript:;" @click="goView(item)">
					<div class="thumb-box" v-if="item.thumbFile !== null && item.thumbFile !== ''" :style="'background-image:url(' + APIs.BOARD_FILES_SHOW + item.thumbIdx + ');'"></div>
					<div class="thumb-box" v-else style="background-image:url(/ssflex/assets/img/common/img_thumb.svg);" ></div>
					<div class="text-box">
						<div class="cate bedge-line">
							<span class="prim">{{ item.cateName }}</span>
							<span class="sec" v-if="item.isNotice">공지</span>
						</div>
						<h3 :style="{ color : item.opt3 }" class="tit">
							<span class="tag mr-2" :class="{ 'end' : (item.statusName === '완료'), 'ing' : (item.statusName === '확인'), 'req' :  !(item.statusName === '완료' || item.statusName === '확인') }" v-if="boardInfo.isStatus && !$options.filters.isEmpty(item.statusCode)">
								<span>{{ item.statusName }}</span>
							</span>
							{{ item.title }}
						</h3>
						<p class="desc">
							{{ item.contentText }}
						</p>
						<ul class="info">
							<li class="like"><span class="blind">좋아요</span>{{ item.likeCount }}</li>
							<li class="view"><span class="blind">조회수</span>{{ item.views }}</li>
							<li class="auth"><span class="blind">작성자</span>{{ item.writerDec }}</li>
						</ul>
					</div>
				</a>
			</li>

			<li v-for="(item, index) in boardList" :id="'item-' + item.idx">
				<a href="javascript:;" @click="goView(item)">
					<div class="thumb-box" v-if="item.thumbFile !== null" :style="'background-image:url(' + APIs.BOARD_FILES_SHOW + item.thumbIdx + ');'" ></div>
					<div class="thumb-box" v-else style="background-image:url(/ssflex/assets/img/common/img_thumb.svg);" ></div>
					<div class="text-box">
						<div class="cate bedge-line">
							<span class="prim">{{ item.cateName }}</span>
							<span class="sec" v-if="item.isNotice">공지</span>
						</div>
						<h3 :style="{ color : item.opt3 }" class="tit">
							<span class="tag mr-2" :class="{ 'end' : (item.statusName === '완료'), 'ing' : (item.statusName === '확인'), 'req' :  !(item.statusName === '완료' || item.statusName === '확인') }" v-if="boardInfo.isStatus && !$options.filters.isEmpty(item.statusCode)">
								<span>{{ item.statusName }}</span>
							</span>
							{{ item.title }}
						</h3>
						<p class="desc">
							{{ item.contentText }}
						</p>
						<ul class="info">
							<li class="like"><span class="blind">좋아요</span>{{ item.likeCount }}</li>
							<li class="view"><span class="blind">조회수</span>{{ item.views }}</li>
							<li class="auth" v-if="!boardInfo.isAnonymous"><span class="blind">작성자</span>{{ item.writerDec }}</li>
						</ul>
					</div>
				</a>
			</li>

		</ul>
	</div>

</template>

<script>
export default {
	name: "listWebzine",
	props: {
		forApp: {
			type: Boolean,
			default: false,
		},
		boardInfo: Object,
		noticeList: Array,
		boardList: Array,
	},
	data() {

		return {

		}
	},
	created() {

	},
	mounted() {

	},
	methods: {

		goView( _item ) {
			if ( this.forApp ) {
				this.goAppBoard( _item.boardKey, _item.idx )
			}
			this.$emit("goBoardOne", _item.idx);
		}

	},
	watch: {
	}
}
</script>

<style scoped>

</style>